import { render, staticRenderFns } from "./RecordPayment.vue?vue&type=template&id=ddc485de&"
import script from "./RecordPayment.vue?vue&type=script&lang=js&"
export * from "./RecordPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports